import MeshData from "./meshdata";

export default class Mesh {
  vertex_buffer: GPUBuffer | null = null;
  index_buffer: GPUBuffer | null = null;
  index_count: number = 0;
  stride_bytes: number = 0;
  skinned: boolean = false;

  build(device: GPUDevice, data: MeshData) {
    this.vertex_buffer = device.createBuffer({
      size: data.vertices.byteLength,
      usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
    });

    device.queue.writeBuffer(
      this.vertex_buffer,
      0,
      data.vertices.buffer,
      data.vertices.byteOffset,
      data.vertices.byteLength
    );

    this.index_buffer = device.createBuffer({
      size: data.indices.byteLength,
      usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
    });

    device.queue.writeBuffer(
      this.index_buffer,
      0,
      data.indices.buffer,
      data.indices.byteOffset,
      data.indices.byteLength
    );

    this.index_count = data.indices.length;
    this.stride_bytes = data.stride_bytes;
    this.skinned = data.skinned;
  }

  draw(pass: GPURenderPassEncoder) {
    if (!this.vertex_buffer || !this.index_buffer || this.index_count === 0) return;

    pass.setVertexBuffer(0, this.vertex_buffer);
    pass.setIndexBuffer(this.index_buffer, "uint16");
    pass.drawIndexed(this.index_count, 1, 0, 0, 0);
  }

  draw_instanced(pass: GPURenderPassEncoder, instance_count: number)
  {
    if (!this.vertex_buffer || !this.index_buffer || this.index_count === 0) return;
    pass.setVertexBuffer(0, this.vertex_buffer);
    pass.setIndexBuffer(this.index_buffer, "uint16");
    pass.drawIndexed(this.index_count, instance_count, 0, 0, 0);
  }
}
